import { render, staticRenderFns } from "./payment-pc.vue?vue&type=template&id=406815f3&scoped=true"
import script from "./payment-pc.vue?vue&type=script&lang=js"
export * from "./payment-pc.vue?vue&type=script&lang=js"
import style0 from "./payment-pc.vue?vue&type=style&index=0&id=406815f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406815f3",
  null
  
)

export default component.exports